import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=4957c200&scoped=true"
import script from "./procedure.vue?vue&type=script&lang=js"
export * from "./procedure.vue?vue&type=script&lang=js"
import style0 from "./procedure.vue?vue&type=style&index=0&id=4957c200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957c200",
  null
  
)

export default component.exports